import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { canActivate, isEmailVerified, isOnboarded } from '@/guards';

//NOTE: this must be included in the Auth0 redirect URIs
export const AUTH_REDIRECT_URI = '';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/universal-remote/apps',
      },
      {
        path: 'tipout',
        title: 'ZagOps Accelerated Pay',
        data: { breadcrumb: 'ZAP' },
        loadChildren: () => import('./app/apps/tipout/tipout.routes'),
        canActivate: [isOnboarded],
      },
      {
        path: 'admin',
        title: 'ZagOps Admin',
        loadChildren: () => import('./app/apps/admin/admin.routes'),
        data: { breadcrumb: 'Admin' },
      },
      {
        path: 'employees',
        title: 'Employees',
        data: { breadcrumb: 'Employees' },
        loadChildren: () => import('./app/apps/employees/employees.routes'),
        canActivate: [isOnboarded],
      },
      {
        path: 'universal-remote',
        title: 'ZagOps Interoperability Platform',
        data: { breadcrumb: 'ZIP' },
        loadChildren: () =>
          import('./app/apps/universal-remote/universal-remote.routes'),
        canActivate: [isOnboarded],
      },
      {
        path: 'management',
        title: 'ZagOps Interoperability Platform',
        data: { breadcrumb: 'Company Management' },
        loadChildren: () => import('./app/apps/management/management.routes'),
        canActivate: [isOnboarded],
      },
      {
        path: 'reports',
        loadChildren: () => import('./app/apps/reports/reports.routes'),
        data: { breadcrumb: 'Reports' },
        canActivate: [isOnboarded],
      },
      {
        path: 'invitations',
        title: 'Account Invitations',
        children: [
          {
            path: '',
            title: 'Invitations',
            loadComponent: () =>
              import('./app/pages/org-member-invitations/org-member-invitations-list').then(
                (c) => c.OrgMemberInvitationsList,
              ),
            data: { breadcrumb: 'Account Invitations' },
            canActivate: [isOnboarded],
          },
          {
            path: 'callback',
            loadComponent: () =>
              import('./app/pages/org-member-invitations/org-member-invitation-callback').then(
                (c) => c.OrgMemberInvitationCallback,
              ),
          },
        ],
      },
      {
        path: 'apps',
        loadChildren: () => import('@/apps/apps.routes'),
        data: { breadcrumb: 'Apps' },
        canActivate: [isOnboarded],
      },
    ],
    canActivate: [canActivate, isEmailVerified],
  },
  {
    path: 'onboarding',
    title: 'Welcome',
    children: [
      {
        path: '',
        title: 'Welcome to ZagOps',
        loadComponent: () =>
          import('./app/pages/onboarding/onboarding').then(
            (c) => c.OnboardingComponent,
          ),
      },
    ],
    canActivate: [canActivate, isEmailVerified],
  },
  { path: 'notfound', component: Notfound },
  {
    path: 'auth',
    loadChildren: () => import('@/pages/auth/auth.routes'),
  },
  { path: '**', title: 'Page Not Found', redirectTo: '/notfound' },
];
